export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuParent, $subMenuItem, $body;

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');

		events();
	}

	function events() {
		$menuButton.click(function () {
			document.body.classList.toggle('mobile-menu-open');
			$menuButton[0].classList.toggle('open');
		});
	}

	return {
		init: init,
	};
})();
